import { combineReducers } from 'redux';

import agent from './agent';
import mine from './mine';
import shareCode from './shareCode';
import upgrade from './upgrade';
import saleOrder from './saleOrder';
import course from './course';
import customer from './customer';
import report from './report';
import team from './team';

export default combineReducers({
  agent,
  mine,
  shareCode,
  upgrade,
  saleOrder,
  course,
  customer,
  report,
  team,
});
